import { render, staticRenderFns } from "./InputRadioCpt.vue?vue&type=template&id=821af630&scoped=true&"
import script from "./InputRadioCpt.vue?vue&type=script&lang=ts&"
export * from "./InputRadioCpt.vue?vue&type=script&lang=ts&"
import style0 from "./InputRadioCpt.vue?vue&type=style&index=0&id=821af630&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821af630",
  null
  
)

export default component.exports